import { Point } from '@view-model/models/common/basic';
import type { RectShape } from '@model-framework/shape';
import { StickyZoneShape } from '@view-model/models/sticky/StickyZoneView';

type Props = {
  position: Point;
  shape: RectShape;
  zoneShape: StickyZoneShape;
  strokeColor: string;
  isHoverSelected: boolean;
  hoverBorderColor: string;
  strokeWidth?: number;
};

export const StickyZoneBasicBorder: React.FC<Props> = ({
  position,
  shape,
  zoneShape,
  strokeColor,
  isHoverSelected,
  hoverBorderColor,
  strokeWidth = 4,
}: Props) => {
  return (
    <g transform={Point.fromPosition(position).toSVGTranslate()}>
      {zoneShape === StickyZoneShape.Rectangle
        ? shape.render({
            strokeWidth,
            fill: 'none',
            stroke: isHoverSelected ? hoverBorderColor : strokeColor,
          })
        : shape.renderEllipse({
            strokeWidth,
            fill: 'none',
            stroke: isHoverSelected ? hoverBorderColor : strokeColor,
          })}
    </g>
  );
};
